// Mirrors app/lib/constants/job_constants.py — update both when changing the allowlist.
export const JOB_MODULE_ALLOWLIST_PREFIXES = [
  'app.data_exporters',
  'app.data_importers',
  'app.lib.data_processors',
  'app.lib.data_exporters',
  'app.lib.data_importers',
  // The module, not the package -- see the note in job_constants.py.
  'app.lib.brand_verified_code_mapping.job',
];
